document.addEventListener('DOMContentLoaded', () => {
    const switch_card = document.querySelectorAll('.card-cambio-colore');
    if(switch_card.length>0){
        switch_card.forEach((item)=>{
            item.addEventListener('click',()=>{
                let src=item.dataset.img;
                let parent = item.closest('.card-wrapper');
                parent.querySelector('.media').classList.add('selezione-custom');
                parent.querySelector('.media img.media--first').setAttribute('src',src);
                parent.querySelector('.media img.media--first').setAttribute('srcset','');
            })
        })
    }
})    